import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DefinitionListCollection from './_DefinitionListCollection';

class Definition extends React.Component {
  constructor() {
    super();
    this.state = { isGroupExpanded: true };

    this.toggleDropdownState = this.toggleDropdownState.bind(this);
  }

  toggleDropdownState() {
    this.setState(isGroupExpanded => ({ isGroupExpanded: !isGroupExpanded }));
  }

  render() {
    const {
      props,
      state,
      toggleDropdownState
    } = this;

    const {
      nestedCells,
      cellContent
    } = props.listItemData;

    const { isGroupExpanded } = state;

    if (nestedCells !== undefined) {
      return (
        <React.Fragment>
          <dd>
            <button
              className='opener button-wrap w-auto'
              title='se detaljer'
              aria-expanded={isGroupExpanded}
              onClick={toggleDropdownState}
            >
              <FontAwesomeIcon icon={(isGroupExpanded) ? 'chevron-up' : 'chevron-down'} />
            </button>
          </dd>

          {!isGroupExpanded ? '' : (
            <dd className='dd-dropdown has-nested-data-list'>
              <DefinitionListCollection listCollectionData={nestedCells} />
            </dd>
          )}
        </React.Fragment>
      );
    }

    return (
      <dd>
        <div className='overflow-limiter'>
          {cellContent.toString()}
        </div>
      </dd>
    );
  }
}

export default Definition;